import {
  Component,
  EventEmitter,
  Input,
  Output,
  ElementRef,
  HostListener,
} from '@angular/core';
import { NgClass } from '@angular/common';
import { ButtonDirective } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { DatePicker } from 'primeng/datepicker';

@Component({
  selector: 'app-created-date-range-header',
  imports: [NgClass, ButtonDirective, FormsModule, DatePicker],
  templateUrl: './created-date-range-header.component.html',
  styleUrl: './created-date-range-header.component.scss',
})
export class CreatedDateRangeHeaderComponent {
  @Input() dateRangeStart: string | null = null;
  @Input() dateRangeEnd: string | null = null;
  @Input() sortColumn?: string;
  @Input() sortDirection?: 'asc' | 'desc';

  @Output() dateRangeChange = new EventEmitter<{
    start: string | null;
    end: string | null;
  }>();
  @Output() sortChanged = new EventEmitter<{
    column?: string;
    direction?: 'asc' | 'desc';
  }>();

  dropdownOpen = false;
  columnKey = 'created_date';

  constructor(private elementRef: ElementRef) {}

  get isActiveSort(): boolean {
    return this.sortColumn === this.columnKey;
  }

  get isFilterActive(): boolean {
    return this.dateRangeStart != null || this.dateRangeEnd != null;
  }

  private formatDate(date: Date | null): string | null {
    if (!date) return null;
    const y = date.getFullYear();
    const m = (date.getMonth() + 1).toString().padStart(2, '0');
    const d = date.getDate().toString().padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  onStartChange(value: Date | null) {
    this.dateRangeChange.emit({
      start: this.formatDate(value),
      end: this.dateRangeEnd,
    });
  }

  onEndChange(value: Date | null) {
    this.dateRangeChange.emit({
      start: this.dateRangeStart,
      end: this.formatDate(value),
    });
  }

  clearFilter() {
    this.dateRangeChange.emit({ start: null, end: null });
  }

  toggleSort() {
    let newDirection: 'asc' | 'desc' | undefined;
    let newColumn: string | undefined;

    if (!this.isActiveSort) {
      newColumn = this.columnKey;
      newDirection = 'asc';
    } else if (this.sortDirection === 'asc') {
      newColumn = this.columnKey;
      newDirection = 'desc';
    } else {
      newColumn = undefined;
      newDirection = undefined;
    }

    this.sortChanged.emit({ column: newColumn, direction: newDirection });
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (
      this.dropdownOpen &&
      !this.elementRef.nativeElement.contains(event.target)
    ) {
      this.dropdownOpen = false;
    }
  }
}
